import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_WIDTH_IMAGE_TEXT_BOX_TOKEN, FullWidthImageTextBoxConverter } from './full-width-image-text-box.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthImageTextBoxFeature: {
          module: () => import('./full-width-image-text-box.module').then((m) => m.FullWidthImageTextBoxModule),
          cmsComponents: ['full_width_image_text_box'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_IMAGE_TEXT_BOX_TOKEN,
      useExisting: FullWidthImageTextBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_image_text_box: FULL_WIDTH_IMAGE_TEXT_BOX_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthImageTextBoxFeatureModule {}
